import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ImportProvider } from './context/ImportContext';
import Layout from './components/layout/Layout';
import ProtectedRoute from './components/common/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import DatabasePage from './pages/DatabasePage';
import OutreachPage from './pages/OutreachPage';
import OutreachProcessPage from './pages/OutreachProcessPage';
import DomainListPage from './pages/DomainListPage';
import OutreachResultsPage from './pages/OutreachResultsPage';
import OutreachValidationPage from './pages/OutreachValidationPage';
import OutreachEmailResultsPage from './pages/OutreachEmailResultsPage';
import OutreachHomePage from './pages/OutreachHomePage';
import SettingsPage from './pages/SettingsPage';
import OutreachScheduledTasksPage from './pages/OutreachScheduledTasksPage';
import OutreachSearchPage from './pages/OutreachSearchPage';
import SavedResultsPage from './pages/SavedResultsPage';
import SitemapPage from './pages/SitemapPage';
import ScrapingPage from './pages/ScrapingPage';
import PipelinePage from './pages/PipelinePage';
import MailwhizImportPage from './pages/MailwhizImportPage';
import WebsiteFinderPage from './pages/WebsiteFinderPage';
import MailwhizCampaignsPage from './pages/MailwhizCampaignsPage';

function App() {
  return (
    <AuthProvider>
      <ImportProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Layout>
                  <Routes>
                    <Route path="/" element={<Navigate to="/database/companies" replace />} />
                    <Route path="/database" element={<DatabasePage />} />
                    <Route path="/database/*" element={<DatabasePage />} />
                    <Route path="/outreach" element={<OutreachHomePage />} />
                    <Route path="/outreach/home" element={<OutreachHomePage />} />
                    <Route path="/outreach/search" element={<OutreachSearchPage />} />
                    <Route path="/outreach/saved-results" element={<SavedResultsPage />} />
                    <Route path="/outreach/upload" element={<OutreachPage />} />
                    <Route path="/outreach/process" element={<OutreachProcessPage />} />
                    <Route path="/outreach/domain-list" element={<DomainListPage />} />
                    <Route path="/outreach/results" element={<OutreachResultsPage />} />
                    <Route path="/outreach/validation" element={<OutreachValidationPage />} />
                    <Route path="/outreach/email-results" element={<OutreachEmailResultsPage />} />
                    <Route path="/outreach/scheduled-tasks" element={<OutreachScheduledTasksPage />} />
                    <Route path="/settings" element={<SettingsPage />} />
                    <Route path="/settings/*" element={<SettingsPage />} />
                    <Route path="/sitemap" element={<SitemapPage />} />
                    <Route path="/scraping" element={<ScrapingPage />} />
                    <Route path="/pipeline" element={<PipelinePage />} />
                    <Route path="/mailwhiz-import" element={<MailwhizImportPage />} />
                    <Route path="/website-finder" element={<WebsiteFinderPage />} />
                    <Route path="/mailwhiz-campaigns" element={<MailwhizCampaignsPage />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </ImportProvider>
    </AuthProvider>
  );
}

export default App;
